/**
 * Axios global setup — adds Authorization: Bearer header from localStorage
 * to every request, alongside cookie credentials.
 * Backend supports both, so this gives us defense-in-depth against
 * browsers that block third-party / cross-site cookies.
 */
import axios from 'axios';

const TOKEN_KEY = 'tk_session_token';

export const setAuthToken = (token) => {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
  }
};

export const clearAuthToken = () => {
  localStorage.removeItem(TOKEN_KEY);
};

export const getAuthToken = () => localStorage.getItem(TOKEN_KEY);

// Always send cookies
axios.defaults.withCredentials = true;

// Attach Bearer header on every outgoing request if we have a token
axios.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token && config.headers && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// On 401, clear stale token (let the page re-prompt login)
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      const detail = error.response.data?.detail || '';
      // Only clear on explicit invalid/missing session, not on bad password attempts
      if (/invalid session|not authenticated/i.test(detail)) {
        clearAuthToken();
      }
    }
    return Promise.reject(error);
  }
);
